import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Input, Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from 'reactstrap';
import api from '../../api/api';

import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

class TableMails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mails: [],
            selectedRow: null
        }
        this.emailInput = React.createRef();
        //console.log(this.emailInput);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mails != this.props.mails) {
            this.setState({ mails: this.props.mails });
        }
    }

    static propTypes = {
        mails: PropTypes.array,
        action: PropTypes.string,
        onChange: PropTypes.func
    }

    onChange = data => {
        this.setState(
            prevState => ({
                mails: prevState.mails.concat(data)
            }),
            () => {
                if (this.props.onChange) this.props.onChange(this.state.mails);
            }
        );
    }

    onDelete = row => {
        this.setState(
            prevState => {
                prevState.mails.splice(row, 1);
                return {
                    mails: prevState.mails,
                    selectedRow: null
                }
            },
            () => {
                if (this.props.onChange) this.props.onChange(this.state.mails);
            }
        );
    }

    onEdit = (data, row) => {
        this.setState(
            prevState => {
                prevState.mails[row] = data;
                return {
                    mails: prevState.mails,
                    selectedRow: null
                }
            },
            () => {
                if (this.props.onChange) this.props.onChange(this.state.mails);
            }
        );
    }

    render() {
        const { mails, selectedRow } = this.state;
        const { action } = this.props;
        return (
            <div className="ui-contact-table">
                { (action === 'CREATE' || action === 'EDIT') &&
                    <Fragment>
                        <ModalMails
                            onChange={this.onChange}
                            action="create"
                        />
                        <ModalMails
                            onEdit={this.onEdit}
                            value={mails[selectedRow]}
                            row={selectedRow}
                            action="edit"
                        />
                    </Fragment>
                }
                <ModalMails
                    value={mails[selectedRow]}
                    row={selectedRow}
                    action="detail"
                />
                { (action === 'CREATE' || action === 'EDIT') &&
                    <ModalMails
                        onDelete={this.onDelete}
                        value={mails[selectedRow]}
                        row={selectedRow}
                        action="delete"
                    />
                }
                <Table size="sm" className="ui-contact-table-grid">
                    <thead>
                        <tr>
                            <th>Mails</th>
                        </tr>
                    </thead>
                    <tbody>
                        { mails.map(
                            (mail, i) =>
                                <tr
                                    key={i}
                                    className={selectedRow === i ? 'is-selected' : ''}
                                    onClick={() => this.setState(prevState => ({
                                        selectedRow: prevState.selectedRow === i ? null : i
                                    }))}
                                >
                                    <td>{mail.email}</td>
                                </tr>
                            )
                        }
                        { mails.length === 0 &&
                            <tr>
                                <td className="text-center ui-contact-table-empty" colSpan={3}>No hay mails</td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>
        );
    }
}

class ModalMails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            descripcion: '',
            isOpen: false
        }
    }

    static propTypes = {
        action: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        onDelete: PropTypes.func,
        disabled: PropTypes.bool
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                id: nextProps.value.id,
                email: nextProps.value.email,
                descripcion: nextProps.value.descripcion
            });
        }
    }

    actionData = {
        delete: {
            icon: 'fa fa-minus',
            color: 'danger',
            title: 'Eliminar mails',
            button: 'Eliminar',
            disabled: true,
            buttonColor: 'danger'
        },
        create: {
            icon: 'fa fa-plus',
            color: 'secondary',
            title: 'Agregar mails',
            button: 'Agregar',
            disabled: false,
            buttonColor: 'success'
        },
        detail: {
            icon: 'fa fa-search',
            color: 'secondary',
            title: 'Ver mails',
            button: false,
            disabled: true
        },
        edit: {
            icon: 'fa fa-pencil',
            color: 'secondary',
            title: 'Editar mails',
            button: 'Guardar',
            disabled: false,
            buttonColor: 'success'
        }
    };

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    close = () => {
        if (this.props.action === 'create') {
            this.setState({
                id: undefined,
                email: '',
                descripcion: '',
            });
        }
        this.toggle();
    }

    onChangeField = (field, value) => {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    onSubmit = () => {
        const { action, row } = this.props;
        const { email, descripcion, id } = this.state;
        const validEmail = email && this.emailInput.checkValidity();
        if (action === 'create') {
            if (validEmail) {
                this.props.onChange({ email, descripcion });
                this.close();
            } else {
                this.setState({ errors: { email: [{detail: 'El mail no es válido.'}] } });
            }
        } else if (action === 'edit') {
            if (validEmail) {
                this.props.onEdit({ email, descripcion, id }, row);
                this.close();
            } else {
                this.setState({ errors: { email: [{detail: 'El mail no es válido.'}] } });
            }
        } else if (action === 'delete') {
            this.props.onDelete(row);
            this.close();
        }
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    render() {
        const { isOpen } = this.state;
        const { action, disabled, row } = this.props;
        const actionData = this.actionData[action];
        return (
            <Fragment>
                { !disabled &&
                    <Button
                        color={actionData['color']}
                        onClick={this.toggle}
                        size="sm"
                        className="mr-1 btn-table-modal rounded"
                        disabled={(action === 'detail' || action === 'delete' || action === 'edit') && (row === null)}
                    >
                        <i className={actionData['icon']} aria-hidden="true"></i>
                    </Button>
                }

                <Modal isOpen={isOpen} toggle={this.toggle} className={"ui-paradigma-modal" + (action === 'delete' ? " modal-danger" : "")}>
                    <ModalHeader toggle={this.toggle}>
                        { actionData['title'] }
                    </ModalHeader>
                    <ModalBody>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Datos del mail</p>
                            <div className="ui-form-stack">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Mail"}
                                    error={() => this.getError('email')}
                                    inputComponent={
                                        <Input
                                            innerRef={x => this.emailInput = x}
                                            type="email"
                                            value={this.state.email}
                                            onChange={e => this.setState({ email: e.target.value, errors: {} })}
                                            disabled={actionData['disabled']}
                                        />
                                    }
                                />
                                <ParadigmaLabeledInput
                                    disabled={actionData['disabled']}
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Descripción"}
                                    type="textarea"
                                    value={this.state.descripcion}
                                    onChange={e => this.onChangeField('descripcion', e.target.value)}
                                />
                            </div>
                        </section>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Cancelar</Button>
                        { actionData['button'] &&
                            <Button color={actionData['buttonColor']} onClick={this.onSubmit} className="mr-1">
                                {actionData['button']}
                            </Button>
                        }
                    </ModalFooter>
                </Modal>

            </Fragment>
        );
    }
}

export default TableMails;



// WEBPACK FOOTER //
// ./src/views/Clientes/TableMails.js